"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isTimeExpired = function (time, duration) { return Date.now() - duration >= time; };
exports.isTimeExpired = isTimeExpired;
//# sourceMappingURL=helpers.js.map